@let tier = content().tier;
@let milesData = content().milesData;
@let action = content().action;
<div
  [class]="
    'skymiles-medallion-banner__details skymiles-medallion-banner__details--' +
    tier.name
  "
  [style.--aura-content]="getLogoUrl(tier)"
>
  <div class="skymiles-medallion-banner__align">
    <div class="skymiles-medallion-banner__details__container">
      <div class="skymiles-medallion-banner__details__container__left">
        <span
          #title
          [class]="
            'skymiles-medallion-banner__details__container__left__title' +
            ' skymiles-medallion-banner__details__container__left__title__default'
          "
        >
          <div
            class="skymiles-medallion-banner__details__container__left__title__default__text"
          >
            {{ content().title.split(',')[0] }},
          </div>
          <div
            [style.width.px]="_titleWidth"
            style="
              white-space: nowrap;
              overflow: var(--aura-overflow-hidden);
              text-overflow: var(--aura-text-overflow-ellipsis);
            "
          >
            {{ content().title.split(',')[1] }}
          </div>
        </span>
        <a
          class="skymiles-medallion-banner__details__container__left__label"
          [href]="action.url"
          role="link"
          target="_blank"
          [attr.aria-label]="action.label"
          (click)="analytics.emit(action)"
        >
          {{ action.label }}
          <span
            aria-hidden="true"
            class="skymiles-medallion-banner__details__container__left__label__icon"
          ></span>
        </a>
      </div>
      <div class="skymiles-medallion-banner__details__container__right">
        <div
          class="skymiles-medallion-banner__details__container__right__skymiles-wrapper"
        >
          <span
            class="skymiles-medallion-banner__details__container__right__skymiles-wrapper__title"
          >
            {{ milesData.skyMiles.title }}
          </span>
          <span
            class="skymiles-medallion-banner__details__container__right__skymiles-wrapper__subtitle"
          >
            {{ milesData.skyMiles.subtitle }}
          </span>
        </div>
        <div
          class="skymiles-medallion-banner__details__container__right__skymiles-wrapper"
        >
          <span
            class="skymiles-medallion-banner__details__container__right__skymiles-wrapper__title"
          >
            {{ milesData.miles.title }}
          </span>
          <span
            class="skymiles-medallion-banner__details__container__right__skymiles-wrapper__subtitle"
          >
            {{ milesData.miles.subtitle }}
          </span>
        </div>
      </div>
      <div
        [class]="
          tier.name === '360'
            ? 'skymiles-medallion-banner__details__container__image skymiles-medallion-banner__details__container__image--360'
            : 'skymiles-medallion-banner__details__container__image '
        "
      >
        <img
          [class]="
            tier.name === '360'
              ? 'skymiles-medallion-banner__details__container__image__content skymiles-medallion-banner__details__container__image__content--360'
              : 'skymiles-medallion-banner__details__container__image__content '
          "
          [alt]="ariaLabel().level"
        />
      </div>
    </div>
  </div>
</div>
